import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Pagetitle from "../Components/Pagetitle";
import AuthContext from "../AuthContext";
import { postData } from "../Api";  

function Login() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await postData("/login", formData);

      if (!response || typeof response !== "object") {
        throw new Error("Invalid API response");
      }

      console.log("Login Success:", response);

      login(response.user);

      setMessage(response.message || "Login successful!");
      setShowModal(true);

      setTimeout(() => {
        navigate("/");
      }, 2000);

      setFormData({ email: "", password: "" });
    } catch (error) {
      console.error("Login Failed:", error);

      if (error.response) {
        alert(
          error.response.data.message ||
            "Login Failed. Please check your credentials."
        );
      } else if (error.request) {
        alert("No response from server. Please try again later.");
      } else {
        alert("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <main className="container-fluid">
        <Header />
        <Pagetitle />
        <section className="row px-sm-5 py-5 justify-content-center">
          <div className="col-lg-6 col-md-8">
            <div className="login-container">
              <h2 className="text-center fw-bold">Login</h2>
              <p className="text-center">
                Please login with your account details
              </p>

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="fw-bold">Email or Phone</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Email or Phone"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="fw-bold">
                    Password (डिफ़ॉल्ट पासवर्ड आपका मोबाइल नंबर है.)
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    placeholder="******"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    minLength={6}
                    maxLength={16}
                    title="कम से कम 6 अंक का पासवर्ड"
                  />
                </div>
                <button
                  type="submit"
                  className="btn-style1 w-100"
                  disabled={loading}
                >
                  {loading ? "Logging in..." : "Login"}
                </button>
              </form>

              <div className="text-center mt-3">
                <Link to="#" className="text-green fw-bold">
                  Forgot your password?
                </Link>
              </div>

              <div className="text-center mt-4">
                <h5 className="fw-bold">Don't Have An Account?</h5>
                <Link to="/register">
                  <button className="btn-style1">Signup</button>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </main>

      {/* ✅ Success Modal */}
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content py-md-5 py-3 rounded-5">
              <div className="modal-body text-center">
                <div className="popup-icon">
                  <FaCheckCircle size={60} color="green" />
                </div>
                <h2 className="py-md-3 py-2">{message}</h2>
              </div>
              <div className="text-center">
                <button
                  type="button"
                  className="btn-style1"
                  onClick={() => navigate("/")}
                >
                  Go to Dashboard
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Login;
